import { useParams } from "react-router-dom";
import {
  useGetPurchaseOrderDetails,
  useGetPurchaseOrderItems,
} from "../../../../../../hooks/api/queries";

export const useEditPurchaseOrder = () => {
  const { id } = useParams();

  const { data: PODetails, isLoading: isLoadingPODetails } =
    useGetPurchaseOrderDetails({ id });

  const { data: POItems, isLoading: isLoadingPOItems } =
    useGetPurchaseOrderItems({ id });

  return {
    isLoading: isLoadingPODetails || isLoadingPOItems,
    PODetails,
    POItems,
  };
};
